import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { Banner, CommonState } from "@obg/ngx.common";
import { CoreUiInteractionEvent, UiInteractionAction } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { TrackingContext } from "@obg/ngx.ui.core";
import { GlideOptions } from "@obg/ngx.ui.global.glide";

import { LgBannerConfigService } from "./lg-banner.config";

@Component({
	selector: "obg-common-lg-banner",
	templateUrl: "./lg-banner.component.html",
	styleUrls: ["./lg-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LgBannerComponent implements OnChanges {
	@HostBinding("class.obg-common-lg-banner") hostCssClass = true;

	@Input()
	banners: Banner[] | undefined;

	@Input()
	width: number | undefined;

	@Input()
	@coerceBoolean()
	showTermsTitle = true;

	glideOptions: GlideOptions = {
		type: "carousel",
		perView: 1,
		focusAt: "center",
		gap: 0,
		autoplay: 7000,
	};

	slideWidth: number;

	constructor(
		bannerConfigService: LgBannerConfigService,
		private uiInteractionAction: UiInteractionAction,
		private store: Store<CommonState & CoreContentState>
	) {
		this.slideWidth = bannerConfigService.getSlideWidth();
	}

	ngOnChanges() {
		if (this.width) {
			this.slideWidth = this.width;
		}
	}

	trackByBanner(_index: number, banner: Banner): string {
		return banner.key;
	}

	onBannerClick(banner: { index: number; key: string }) {
		this.store.dispatch(
			this.uiInteractionAction.emit({
				context: TrackingContext.BannerInteractionContext,
				event: CoreUiInteractionEvent.Click,
				data: {
					BannerPosition: banner.index + 1,
					BannerName: banner.key,
				},
			})
		);
	}
}
